module.exports = __webpack_public_path__ + "static/media/twitter.daeb1701.svg";